<template>
  <page>
    <list-table :group="$route.meta.type" />
  </page>
</template>

<script>
import Page from "../../components/Page";
import ListTable from "../../components/user-management/ListTable";

export default {
  name: "UserList",
  components: { ListTable, Page }
};
</script>

<style scoped></style>
